<template>
    <div class="table-headers">
        <div class="table-header-cell record-id-header">
            <a-checkbox
                :checked="isAllSelected"
                @change="$emit('toggle-select-all', $event.target.checked)"
            ></a-checkbox>
        </div>
        <div
            v-for="field in visibleFields"
            :key="field._id"
            class="table-header-cell"
            :class="{ selected: selectedField === field }"
            @click="selectField(field)"
        >
            <a-popover trigger="click" placement="bottomLeft">
                <template slot="content">
                    <div class="action-list field-actions-menu">
                        <div class="action-item" @click="handleAction('editField', field)">
                            <i class="material-icons">edit</i>
                            <span>Edit Field</span>
                        </div>
                        <a-divider />
                        <div class="action-group">
                            <div class="group-name">Sort</div>
                            <div class="action-item" @click="handleAction('sortAscending', field)">
                                <i class="material-icons">arrow_upward</i>
                                <span>Ascending</span>
                            </div>
                            <div class="action-item" @click="handleAction('sortDescending', field)">
                                <i class="material-icons">arrow_downward</i>
                                <span>Descending</span>
                            </div>
                        </div>
                        <a-divider />
                        <div class="action-group">
                            <div class="group-name">Create Field</div>
                            <div class="action-item" @click="handleAction('insertBefore', field)">
                                <i class="material-icons">add</i>
                                <span>Insert Before</span>
                            </div>
                            <div class="action-item" @click="handleAction('insertAfter', field)">
                                <i class="material-icons">add</i>
                                <span>Insert After</span>
                            </div>
                        </div>
                        <a-divider />
                        <div class="action-group">
                            <div class="group-name">Automation</div>
                            <div
                                class="action-item"
                                @click="handleAction('gotoAutomation', field)"
                                v-if="field.fieldType === 'automation-button'"
                            >
                                <component is="atomic-power" class="myIcon" />
                                <span>Go to Related Automation</span>
                            </div>
                            <div class="action-item" @click="handleAction('createAutomation', field)">
                                <i class="material-icons">settings_suggest</i>
                                <span>Create Automation</span>
                            </div>
                        </div>
                        <a-divider />
                        <div class="action-group">
                            <div class="group-name">Permissions</div>
                            <div class="action-item" @click="handleAction('lockField', field)">
                                <i class="material-icons">lock</i>
                                <span>Lock Field</span>
                            </div>
                            <div class="action-item" @click="handleAction('hideField', field)">
                                <i class="material-icons">visibility_off</i>
                                <span>Hide Field</span>
                            </div>
                        </div>
                        <a-divider />
                        <div class="action-item" @click="handleAction('deleteField', field)">
                            <i class="material-icons">delete</i>
                            <span>Delete Field</span>
                        </div>
                    </div>
                </template>
                <div class="table-header-cell-content">
                    <i class="material-icons mr-2">{{ getIcon(field) }}</i>
                    <span>{{ field.name }}</span>
                </div>
            </a-popover>
        </div>
        <!-- "Add Field" hücresi ve popover -->
        <div class="table-header-cell add-field-cell">
            <a-popover ref="addFieldPopover" trigger="click" placement="bottomRight">
                <template slot="content">
                    <FieldSelector @field-selected="openFieldCreator" />
                </template>
                <span>+ {{ $t("calendar.addField") }}</span>
            </a-popover>
        </div>

        <!-- FieldCreator'ı Modal2 içinde göster -->
        <Modal2 v-if="isFieldCreatorVisible" :title="$t('tables.createNewField')" @cancel="closeFieldCreator" :showFooter="false">
            <FieldCreator
                :defaultFieldType="selectedFieldType"
                :table-id="table._id"
                @field-created-success="onFieldCreated"
                @cancel="closeFieldCreator"
            />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import FieldSelector from "./components/FieldSelector.vue";
import FieldCreator from "./components/FieldCreator.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import { TABLE_API } from "../../../../api/table";

export default Vue.extend({
    name: "TableHeaders",
    components: {
        FieldSelector,
        FieldCreator,
        Modal2,
    },
    props: {
        table: {
            type: Object,
            required: true,
        },
        isSelectionModeActive: Boolean,
        selectedRecords: Array,
        isAllSelected: Boolean,
        visibleFields: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isFieldCreatorVisible: false,
            selectedFieldType: null,
            selectedField: null,
        };
    },
    methods: {
        getIcon(field) {
            if (field.icon) {
                return field.icon;
            }

            switch (field.fieldType) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                case "currency":
                    return "attach_money";
                case "datetime":
                    return "event";
                case "dropdown":
                    return "arrow_drop_down";
                case "checkbox":
                    return "check_box";
                case "url":
                    return "link";
                case "email":
                    return "email";
                case "phone":
                    return "phone";
                case "json":
                    return "code";
                case "file":
                    return "attachment";
                case "image":
                    return "image";
                case "video":
                    return "videocam";
                case "audio":
                    return "audiotrack";
                case "color":
                    return "palette";
                case "automation-button":
                    return "smart_button";
                default:
                    return "help_outline";
            }
        },
        openFieldCreator(fieldType) {
            // Seçilen fieldType'ı kaydet ve Modal'ı aç
            this.selectedFieldType = fieldType;
            this.isFieldCreatorVisible = true;
        },
        closeFieldCreator() {
            // Modal'ı kapat ve seçili fieldType'ı sıfırla
            this.isFieldCreatorVisible = false;
            this.selectedFieldType = null;
            // Popover'ı kapat
            this.$refs.addFieldPopover && this.$refs.addFieldPopover?.hide();
        },
        onFieldCreated() {
            // Üst componente tabloyu yenilemesini bildir
            this.$emit("refresh-table");
            // Modal'ı kapat
            this.closeFieldCreator();
        },
        handleAction(action, field) {
            switch (action) {
                case "editField":
                    // Edit field logic
                    break;
                case "sortAscending":
                    // Sort ascending logic
                    break;
                case "sortDescending":
                    // Sort descending logic
                    break;
                case "insertBefore":
                    // Insert before logic
                    break;
                case "insertAfter":
                    // Insert after logic
                    break;
                case "createAutomation":
                    // Create automation logic
                    break;
                case "lockField":
                    // Lock field logic
                    break;
                case "hideField":
                    this.$emit("hide-field", field._id);
                    break;
                case "deleteField":
                    this.confirmDeleteField(field);
                    break;
                case "gotoAutomation":
                    const automationId = field.options.button.automation;
                    this.$router.push(`/automations/${automationId}/design`);
                    break;
            }
        },
        selectField(field) {
            this.selectedField = field;
        },
        async confirmDeleteField(field) {
            try {
                const confirmed = await this.$confirm({
                    title: "Alanı Sil",
                    content: `"${field.name}" alanını silmek istediğinize emin misiniz?`,
                    okText: "Evet",
                    okType: "danger",
                    cancelText: "Hayır",
                    onOk: async () => {
                        await TABLE_API.deleteField(this.table._id, field._id);
                        this.$emit("refresh-table");
                        this.$message.success("Alan başarıyla silindi.");
                    },
                });
            } catch (error) {
                if (error.message !== "cancel") {
                    console.error("Alanı silerken hata oluştu:", error);
                    this.$message.error("Alanı silerken bir hata oluştu.");
                }
            }
        },
    },
});
</script>

<style scoped lang="scss">
.table-headers {
    width: max-content;
    display: flex;
    border-top: 1px solid #ccc;
}

.table-header-cell {
    width: 245px;
    min-width: 245px;
    padding: 0 15px;
    height: 40px;
    display: flex;
    align-items: center;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    cursor: pointer;

    &.selected {
        border: 2px solid #1890ff;
    }

    &:last-child {
        border-right: none;
    }

    .table-header-cell-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
}

.add-field-cell {
    color: #007bff;
    cursor: pointer;
}

.material-icons {
    font-size: 18px;
}

.record-id-header {
    justify-content: center;
}

.action-list {
    min-width: 200px;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        i {
            margin-right: 8px;
        }
    }

    .action-group {
        .group-name {
            font-weight: bold;
            margin-bottom: 4px;
        }
    }
}
</style>
<style lang="scss">
.field-actions-menu {
    .ant-divider-horizontal {
        margin: 5px 0;
    }
}
</style>
